import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import { makeMockClient } from './supabaseMock'

// Public project config baked as defaults so the app works without relying on the host's
// build-time env injection. The anon key is PUBLIC by design — it ships in the client bundle
// regardless, and Row-Level Security enforces per-user access. Env vars override for self-hosting.
const DEFAULT_URL = 'https://auwmkbfpzqzlhuyfzdnq.supabase.co'
const DEFAULT_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF1d21rYmZwenF6bGh1eWZ6ZG5xIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUxMzQ3MDYsImV4cCI6MjEwMDcxMDcwNn0.lVOZwDujhNTtj3QU8X5VE9rJhxekr3LzypFyXmZp4vc'

const url = import.meta.env.VITE_SUPABASE_URL || DEFAULT_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY || DEFAULT_ANON
const demo = import.meta.env.VITE_DEMO === '1'

export const hasSupabaseConfig = true

export const supabase: SupabaseClient = demo
  ? (makeMockClient() as unknown as SupabaseClient)
  : createClient(url, anon, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
